import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';

import { Intl } from 'components';
import { Button } from 'reactstrap';

export default ( {
  open, onConfirm, onClose, title, confirmBtnText, subtitle, translateValues, translateTitle = true,
  confirmClose, okLabel, noCancelBtn
} ) => (
  <SweetAlert
    show={open}
    customClass="sweetalert-confirmation"
    title={(
      <div className="d-flex flex-column justify-content-between">
        <i className="fa fa-times text-gray-7 p-3 cursor-pointer text-right" onClick={confirmClose ? onConfirm : onClose} />
        <div className="text-body text-md font-weight-400">
          <span className="d-block">
            {/* eslint-disable-next-line no-nested-ternary */}
            {title ? translateTitle ? <Intl id={title} /> : title
              : <Intl id="deleteModal.confirmation" values={translateValues} />}
          </span>
          <span className="d-block">
            {!!subtitle && <Intl id={subtitle} />}
          </span>
        </div>
      </div>
    )}
    customButtons={(
      <>
        <Button
          color="app-default"
          size="app-sm"
          type="button"
          className="font-weight-700"
          onClick={onConfirm}
        >
          {confirmBtnText
            ? <Intl id={confirmBtnText} /> : <Intl id={okLabel || 'okBtn'} />}
        </Button>
        {!!onClose && !noCancelBtn
        && (
          <Button
            color="app-default"
            size="app-sm"
            type="button"
            className="font-weight-700"
            onClick={onClose}
          >
            <Intl id="cancelBtn" />
          </Button>
        )}
      </>
    )}
    onConfirm={onConfirm}
    onCancel={onClose}
  />
);
